"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGameList = void 0;
var _request = _interopRequireDefault(require("../utils/request"));
var _consts = require("../consts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * @Author: tianhaiting
 * @Date: 2023/1/14
 * @Desc:
 */

/**
 *
 * @param  cash：游戏是否支持支付   activation：游戏师傅已激活
 */
var getGameList = function getGameList() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    cash: '',
    activation: ''
  };
  var params = '';
  var paramsArr = [];
  param.cash && paramsArr.push('cash=cash');
  param.activation && paramsArr.push('activation=activation');
  params = paramsArr.join('&');
  return _request.default.get("".concat(_consts.SQGameServer_URL, "/gameserver/game/list?").concat(params));
};
exports.getGameList = getGameList;